import React, { useEffect } from "react";
import styled from "styled-components";
import pawPrintlogo from "../../Assets/Images/Navbar/pawprint-icon.png";


function SuccessPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Main>
      <SuccessCard>
        <IconContainer>
          <SuccessIcon src={pawPrintlogo} alt="Success" />
        </IconContainer>
        <Title>Registration Completed</Title>
        <Message>
          Thank you for registering with FootprintID®. You have taken the first
          step towards protecting yourself and your family. You will receive two
          emails shortly, one confirming your order, and one with an activation
          link to safeguard your identity. Once you have activated your
          membership, you will be able to start setting up the medical history and
          information for each member.
        </Message>
      </SuccessCard>
    </Main>
  );
}

export default SuccessPage;

const Main = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;

  @media (max-width: 768px) {
    padding: 15px;
  }

  @media (max-width: 480px) {
    padding: 10px;
  }
`;

const SuccessCard = styled.div`
  background: white;
  border-radius: 20px;
  padding: 28px;
  max-width: 600px;
  width: 100%;
  text-align: center;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);

  @media (max-width: 768px) {
    padding: 24px;
    border-radius: 16px;
    max-width: 500px;
  }

  @media (max-width: 480px) {
    padding: 20px;
    border-radius: 12px;
    max-width: 100%;
  }
`;

const IconContainer = styled.div`
  margin-bottom: 30px;

  @media (max-width: 768px) {
    margin-bottom: 25px;
  }

  @media (max-width: 480px) {
    margin-bottom: 20px;
  }
`;

const SuccessIcon = styled.img`
  @media (max-width: 768px) {
    max-width: 100%;
    height: auto;
  }

  @media (max-width: 480px) {
    max-width: 100%;
    height: auto;
  }
`;

const Title = styled.h1`
  color: var(--blue-color-400);
  font-size: 32px;
  font-weight: 700;
  font-family: "Omnes", sans-serif;
  line-height: 1.2;

  @media (max-width: 768px) {
    font-size: 28px;
  }

  @media (max-width: 480px) {
    font-size: 24px;
  }
`;

const Message = styled.p`
  font-size: 16px;
  line-height: 1.6;
  font-family: "Omnes", sans-serif;

  @media (max-width: 768px) {
    font-size: 15px;
  }

  @media (max-width: 480px) {
    font-size: 14px;
    line-height: 1.5;
  }
`;
